import { API, Auth } from 'aws-amplify';
const getVideo = (baseUrl, login) => login.cloudFront + baseUrl + login.cookie;

const GetUserVideo = async (newUrl, login=null) => {
  if (newUrl.includes('appfiles') && login) {
    return getVideo(newUrl, login);
  } else {
    const myInit = {
      body: { key: newUrl },
    };
    const urlFound = await API.post('TIR', '/v3/student/url/download', myInit);
    return urlFound.presigned_url;
  }
};

export { getVideo, GetUserVideo };
